import { notify } from 'components/notification';

export const handleApiErrorResponse = (error: Error) => {
  console.error(error);

  let message = 'Something went wrong';
  if (error?.message) {
    try {
      message = JSON.parse(error.message).message;
    } catch (e) {
      message = error.message;
    }
  }
  notify({ content: message, type: 'error' });
};
